module.exports = __webpack_public_path__ + "img/img-sitio-anter-TEO.eb11b9b6.svg";